import { useTranslation } from "react-i18next";
import { t } from "../../hooks/useAppTranslation";
/* eslint-disable no-unused-expressions */
import React, {useEffect, useState} from 'react';
import '../ControlDetail/ControlDetail.css';
import {connect} from 'react-redux';
import {ExternalControlDetailInfo} from './ExternalControlDetailInfo';
import * as PropertyBucket from '../../Properties/Properties';
import {Waiter} from '../WaitingSign/Waiting';
import * as httpService from '../HttpService/HttpService';
import * as actionsControl from '../../Redux/Actions/Controls'
import PopUp from "../PopUp/PopUp";

export const GET_CONTROLS_REQUESTED = 'GET_CONTROLS_REQUESTED';
export const GET_CONTROLS_DONE = 'GET_CONTROLS_DONE';
export const GET_CONTROLS_FAILED = 'GET_CONTROLS_FAILED';

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		controlData: (controlId) => dispatch(actionsControl.getSingleControlData(controlId))
	}
};

export const ExternalControlDetailProvider = connect(mapStateToProps, mapDispatchToProps)(props => {
	const { i18n } = useTranslation();
	const lang = i18n.language

	const [controlId, setControlId] = useState();
	const [isWaiting, setIsWaiting] = useState(true);
	const [loadedControlData, setLoadedControlData] = useState(null);
	const [controlResponse, setControlResponse] = useState();
	const [showPopup, setShowPopup] = useState(false)
	const [popup, setPopup] = useState({notification: null, type: null, title: null})


	useEffect(() => {
		setControlId(props.match.params.controlId);
		const url = PropertyBucket.getExtenalControlDetailById(props.match.params.controlId, lang);
		setControlResponse(httpService.getService(url, 'GET').catch(error => {
			setShowPopup(true)
			setPopup({
				notification: error.message || t('g-unknown-error'),
				type: 'error',
				title:  t('g-error')
			})
		}));
	}, [lang]);
	
	useEffect(() => {
		if (controlId && controlResponse) {
			controlResponse
				.then(data => {
					setLoadedControlData(data);
					setIsWaiting(false);
				})
		}
		document.title = `e-Kontrole | Szczegóły kontroli: ${loadedControlData?.number}`;
	}, [controlId, controlResponse, loadedControlData]);

	const goBack = () => {
		props.history.goBack();
	};

	return (
		<>
			<button 
				className='btn save-btn' 
				id='plus_img_container' 
				onClick={goBack}
			>
				<i data-v-db6946bc='' aria-hidden='true' className='v-icon material-icons theme--light v-list-text'>
					arrow_back
				</i>
				<span className="uppercase">{t('g-back')}<span className='sr-only'>{t('external-controls-registered-controls-eview-controls')}</span></span>
			</button>

			<h3>{t('external-controls-control-details')} </h3>
			{isWaiting === false ? <ExternalControlDetailInfo control={loadedControlData}/> : null}
			{showPopup &&
				<PopUp
					type={popup.type}
					title={popup.title}
					notification={popup.notification}
					closePopUp={() => setShowPopup(false)}
				/>}
			<div id='waiter'><Waiter loading={isWaiting}/></div>
		</>
	);
});
